import React from 'react';
import settings from 'settings';

const BHPLogo = require('assets/images/logo/bhp_logo.svg');
const BHPLogoLocal = require('assets/images/logo/rooster_local_with_word.svg');
const BHPLogoDev = require('assets/images/logo/rooster_dev_with_word.svg');
const BHPLogoTest = require('assets/images/logo/rooster_test_with_word.svg');
const BHPLogoQA = require('assets/images/logo/rooster_qa_with_word.svg');
const BHPLogoProd = require('assets/images/logo/rooster_prod_with_word.svg');

const AppLogo = () => {
    const env = settings.APP_CONFIG.environment.toLowerCase();
    const version = settings.APP_CONFIG.versionNo.toLowerCase();
    let logo = BHPLogo; // Fallback/Default logo
    let mouseOverText = '';
    if (env === 'dev') {
      logo = BHPLogoDev;
      mouseOverText = `Crew Rostering DEV \nVersion: ${version}`;
    // eslint-disable-next-line brace-style
    } else if (env === 'test') {
      logo = BHPLogoTest;
      mouseOverText = `Crew Rostering TEST \nVersion: ${version}`;
    // eslint-disable-next-line brace-style
    } else if (env === 'qa') {
      logo = BHPLogoQA;
      mouseOverText = `Crew Rostering QA \nVersion: ${version}`;
    // eslint-disable-next-line brace-style
    } else if (env === 'prod') {
      logo = BHPLogoProd;
      mouseOverText = `Crew Rostering Production \nVersion: ${version}`;
    // eslint-disable-next-line brace-style
    } else if (env === 'local') {
      logo = BHPLogoLocal;
      mouseOverText = `Crew Rostering LOCAL \nVersion: ${version}`;
    // eslint-disable-next-line brace-style
    } else {
      mouseOverText = `Crew Rostering (Unknown Environment) \nVersion: ${version}`;
    }
    return (
      <img src={logo} title={mouseOverText} />
    );
};
export default AppLogo;
